import React, {
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
} from "react";
import { useSnackbar } from "notistack";
import {
  fetchProvincias,
  fetchCantones,
  fetchParroquias,
  fetchBarrios,
  fetchTiempoVivienda,
  fetchTipoIngreso,
  fetchDiaIngreso,
  fetchMetodoPago,
} from "../DatosCliente/apisFetch";
import { APIURL } from "../../../configApi/apiConfig";
import axios from "../../../configApi/axiosConfig";
import {
  FaStoreAlt,
  FaMoneyCheckAlt,
  FaMapMarkerAlt,
  FaClock,
  FaCity,
  FaMoneyBillWave,
  FaRoad,
  FaHouseUser,
  FaMapPin,
  FaRulerCombined,
  FaIndustry,
  FaPhoneAlt,
  FaStore,
  FaMobileAlt,
} from "react-icons/fa";
import { SelectField } from "../../Utils";
import { LocationModal } from "../LocationModal";
import { useAuth } from "../../AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { GoogleMapModal } from "../../ListadoSolicitud/DomicilioModal"
const SeccionA = forwardRef((props, ref) => {

  const location = useLocation();
  const [clientInfo, setClientInfo] = useState(null);
  useEffect(() => {
    if (location.state) {
      // Si hay datos en `location.state`, los guardamos en localStorage
      localStorage.setItem("clientInfo", JSON.stringify(location.state));
      setClientInfo(location.state);
    } else {
      // Si no hay datos en `location.state`, intentamos recuperar de localStorage
      const savedClientInfo = localStorage.getItem("clientInfo");
      if (savedClientInfo) {
        setClientInfo(JSON.parse(savedClientInfo));
      }
    }
  }, [location.state]);



  const { userData, userUsuario } = useAuth();
  const { data } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [nombreNegocio, setNombreNegocio] = useState("");
  const [tiempoNegocio, setTiempoNegocio] = useState([]);
  const [metros, setMetros] = useState("");
  const [ingresos, setIngresos] = useState("");
  const [gastos, setGastos] = useState("");
  const [provincia, setProvincia] = useState([]);
  const [canton, setCanton] = useState([]);
  const [parroquia, setParroquia] = useState([]);
  const [barrio, setBarrio] = useState([]);
  const [callePrincipal, setCallePrincipal] = useState("");
  const [numeroCasa, setNumeroCasa] = useState("");
  const [calleSecundaria, setCalleSecundaria] = useState("");
  const [referenciaUbicacion, setReferenciaUbicacion] = useState("");
  const [actividadNegocio, setActividadNegocio] = useState("");
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [ubicacionError, setUbicacionError] = useState(false);
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    nombreNegocio: data.NombreNegocio || "",
    tiempoNegocio: data.idCre_TiempoNegocio || "",
    metros: data.MetrosCuadrados || 0,
    ingresos: data.IngresosNegosio || 0,
    gastos: data.EgresosNegocio || 0,
    provincia: data.idProvinciaNegocio || 0,
    canton: data.idCantonNegocio || 0,
    parroquia: data.idParroquiaNegocio || 0,
    barrio: data.idBarrioNegocio || 0,
    callePrincipal: data.CallePrincipalNegocio || "",
    numeroCasa: data.NumeroCasaNegocio || "",
    calleSecundaria: data.CalleSecundariaNegocio || "",
    referenciaUbicacion: data.ReferenciaUbicacionNegocio || "",
    actividadNegocio: data.ActividadEconomicaNegocio || "",
    AfiliadoTributario: data.AfiliadoTributario || false,
    ObligadoContabilidad: data.ObligadoContabilidad || false,
    telefono: data.TelefonoNegocio || "",
    celular: data.CelularNegocio || "",
    jefeInmediato: data.JefeInmediatoIndependiente || "",
    numeroJefe: data.CelularInmediatoIndependiente || "",
    idTipoIngreso: data.idTipoIngreso ?? 0,
    idDiaIngreso: data.idDiaIngreso ?? 0,
    iHora: data.iHora ?? 12,
    idMetododePago: data.idMetododePago ?? 0
  });
  const [showMapModal, setShowMapModal] = useState(false);
  const [Latitud, setLatitud] = useState("");
  const [Longitud, setLongitud] = useState("");

  const [tipoIngresoList, setTipoIngresoList] = useState([]);
  const [diaIngresoList, setDiaIngresoList] = useState([]);
  const [metodoPagoList, setMetodoPagoList] = useState([]);

  useEffect(() => {
    fetchTiempoVivienda(enqueueSnackbar, setTiempoNegocio);
    fetchProvincias(enqueueSnackbar, setProvincia);
    fetchTipoIngreso(enqueueSnackbar, setTipoIngresoList);
    fetchDiaIngreso(enqueueSnackbar, setDiaIngresoList);
    fetchMetodoPago(enqueueSnackbar, setMetodoPagoList);
  }, []);

  useEffect(() => {
    if (formData.provincia) {
      fetchCantones(formData.provincia, enqueueSnackbar, setCanton);
    }
  }, [formData.provincia, enqueueSnackbar]);

  useEffect(() => {
    if (formData.canton) {
      fetchParroquias(formData.canton, enqueueSnackbar, setParroquia);
    }
  }, [formData.canton, enqueueSnackbar]);

  useEffect(() => {
    if (formData.parroquia) {
      fetchBarrios(formData.parroquia, enqueueSnackbar, setBarrio);
    }
  }, [formData.parroquia, enqueueSnackbar]);

  const fecthValidaDomicilio = async () => {
    try {

      const idCre_SolicitudWeb = data.idCre_SolicitudWeb;
      const url = APIURL.getCoordenadasprefacturaPorId(idCre_SolicitudWeb, 1);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.data) {
        return response.data; // Return the fetched data
      } else {
        console.error("No se encontraron datos para la solicitud.");
        return null; // Return null if no data is found
      }
    } catch (error) {
      console.error("Error al obtener los datos del cliente", error);
      return null; // Return null in case of an error
    }
  };


  const handleOpenModal = () => {
    setOpenLocationModal((prev) => !prev);
  };

  const handleFormChange = async (e) => {
    const { name, value, type, checked } = e.target;

    // Validación para campos de teléfono
    if (name === 'telefono' || name === 'celular' || name === 'numeroJefe') {
      // Solo validar si el campo tiene valor y tiene la longitud correcta
      if (value && (value.length === 9 || value.length === 10)) {
        const existe = await props.comprobTelf(value);
        if (existe === 1) {
          enqueueSnackbar(`El número ${value} se encuentra en la lista negra`, {
            variant: 'warning'
          });
          return;
        }
      }
    }
    // Expresión regular para detectar caracteres no permitidos
    const invalidCharsRegex = /[<>'"\\;{}()[\]`~!@#$%^&*=+|/?]/g;

    if (invalidCharsRegex.test(value)) {
      // Si hay caracteres no permitidos, los eliminamos y actualizamos formData y formErrors
      const cleanedValue = value.replace(invalidCharsRegex, "");

      setFormData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Este campo contiene caracteres no permitidos",
      }));

      return;
    }

    // Si el valor es válido, actualizar normalmente
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Limpiar el error si el valor es válido
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }

    if (name === "provincia" && value) {
      fetchCantones(value, enqueueSnackbar, setCanton);
      setCanton([]);
      setParroquia([]);
      setBarrio([]);
      setFormData((prev) => ({
        ...prev,
        canton: "",
        parroquia: "",
        barrio: "",
      }));
    }

    if (name === "canton" && value) {
      fetchParroquias(value, enqueueSnackbar, setParroquia);
      setParroquia([]);
      setBarrio([]);
      setFormData((prev) => ({ ...prev, parroquia: "", barrio: "" }));
    }

    if (name === "parroquia" && value) {
      fetchBarrios(value, enqueueSnackbar, setBarrio);
      setBarrio([]);
      setFormData((prev) => ({ ...prev, barrio: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let showSnackbar = false;

    const addError = (field, errorMsg, snackbarMsg) => {
      newErrors[field] = errorMsg;
      if (!showSnackbar) {
        enqueueSnackbar(snackbarMsg, { variant: "error" });
        showSnackbar = true;
      }
    };

    const rules = [
      { field: "nombreNegocio", condition: !formData.nombreNegocio || formData.nombreNegocio.length <= 3, error: "Este campo es obligatorio", snackbar: "El nombre del negocio debe tener más de 3 caracteres" },
      { field: "tiempoNegocio", condition: !formData.tiempoNegocio || formData.tiempoNegocio <= 0 || formData.tiempoNegocio > 100000000000, error: "Este campo es obligatorio", snackbar: "El tiempo del negocio debe ser un número mayor a 0" },
      { field: "metros", condition: !formData.metros || formData.metros <= 0 || formData.metros > 100000000000, error: "Este campo es obligatorio", snackbar: "Los metros deben ser un número mayor a 0" },
      { field: "numeroJefe", condition: formData.numeroJefe.length !== 10, error: "El teléfono debe tener 10 dígitos", snackbar: "El teléfono debe tener 10 dígitos" },
      { field: "numeroJefe", condition: formData.numeroJefe && !formData.numeroJefe.startsWith("09"), error: "El celular debe empezar con 09", snackbar: "Por favor, proporciona un celular valido" },
      { field: "jefeInmediato", condition: !formData.jefeInmediato || formData.jefeInmediato.length <= 3, error: "Este campo es obligatorio", snackbar: "El nombre del jefe inmediato debe tener más de 3 caracteres" },
      { field: "ingresos", condition: !formData.ingresos || formData.ingresos <= 0 || formData.ingresos > 100000000000, error: "Este campo es obligatorio", snackbar: "Los ingresos deben ser un número mayor a 0" },
      { field: "gastos", condition: !formData.gastos || formData.gastos <= 0 || formData.gastos > 100000000000, error: "Este campo es obligatorio", snackbar: "Los gastos deben ser un número mayor a 0" },
      { field: "gastos", condition: Number(formData.gastos) > Number(formData.ingresos), error: "Los gastos no pueden ser mayores a los ingresos", snackbar: "Los gastos no pueden ser mayores a los ingresos" },
      { field: "provincia", condition: !formData.provincia, error: "Este campo es obligatorio", snackbar: "La provincia es obligatoria" },
      { field: "canton", condition: !formData.canton, error: "Este campo es obligatorio", snackbar: "El cantón es obligatorio" },
      { field: "parroquia", condition: !formData.parroquia, error: "Este campo es obligatorio", snackbar: "La parroquia es obligatoria" },
      { field: "barrio", condition: !formData.barrio, error: "Este campo es obligatorio", snackbar: "El barrio es obligatorio" },
      { field: "barrio", condition: formData.barrio && formData.barrio.length > 100, error: "El barrio no debe exceder los 100 caracteres", snackbar: "El barrio no debe exceder los 100 caracteres" },
      { field: "telefono", condition: formData.telefono !== "" && formData.telefono.length !== 9, error: "El teléfono debe tener 9 dígitos", snackbar: "El teléfono debe tener 9 dígitos" },
      { field: "telefono", condition: formData.telefono !== "" && !['02', '03', '04', '05', '06', '07'].some(prefix => formData.telefono.startsWith(prefix)), error: "El teléfono debe empezar con 02, 03, 04, 05, 06, 07", snackbar: "Por favor, proporciona un teléfono valido" },
      { field: "celular", condition: formData.celular !== "" && !formData.celular.startsWith("09"), error: "El celular debe empezar con 09", snackbar: "Por favor, proporciona un celular valido" },
      { field: "celular", condition: formData.celular !== "" && !/^\d{10}$/.test(formData.celular), error: "El celular debe tener exactamente 10 dígitos numéricos", snackbar: "El celular debe tener exactamente 10 dígitos numéricos" },
      { field: "callePrincipal", condition: !formData.callePrincipal, error: "Este campo es obligatorio", snackbar: "La calle principal es obligatoria" },
      { field: "callePrincipal", condition: formData.callePrincipal && formData.callePrincipal.length > 100, error: "La calle principal no debe exceder los 100 caracteres", snackbar: "La calle principal no debe exceder los 100 caracteres" },
      { field: "numeroCasa", condition: !formData.numeroCasa, error: "Este campo es obligatorio", snackbar: "El número de casa es obligatorio" },
      { field: "calleSecundaria", condition: !formData.calleSecundaria, error: "Este campo es obligatorio", snackbar: "La calle secundaria es obligatoria" },
      { field: "calleSecundaria", condition: formData.calleSecundaria && formData.calleSecundaria.length > 100, error: "La calle secundaria no debe exceder los 100 caracteres", snackbar: "La calle secundaria no debe exceder los 100 caracteres" },
      { field: "referenciaUbicacion", condition: !formData.referenciaUbicacion, error: "Este campo es obligatorio", snackbar: "La referencia de ubicación es obligatoria" },
      { field: "referenciaUbicacion", condition: formData.referenciaUbicacion && formData.referenciaUbicacion.length > 300, error: "La referencia de ubicación no debe exceder los 300 caracteres", snackbar: "La referencia de ubicación no debe exceder los 300 caracteres" },
      { field: "actividadNegocio", condition: !formData.actividadNegocio, error: "Este campo es obligatorio", snackbar: "La actividad del negocio es obligatoria" },
      { field: "actividadNegocio", condition: formData.actividadNegocio && formData.actividadNegocio.length > 300, error: "La actividad del negocio no debe exceder los 300 caracteres", snackbar: "La actividad del negocio no debe exceder los 300 caracteres" },
      { field: "idTipoIngreso", condition: !formData.idTipoIngreso || formData.idTipoIngreso === 0, error: "Este campo es obligatorio", snackbar: "El tipo de ingreso es obligatorio" },
      { field: "idDiaIngreso", condition: !formData.idDiaIngreso || formData.idDiaIngreso === 0, error: "Este campo es obligatorio", snackbar: "El día de ingreso es obligatorio" },
      { field: "iHora", condition: formData.iHora === "" || formData.iHora === null || formData.iHora === undefined || formData.iHora < 0 || formData.iHora > 23, error: "Hora inválida", snackbar: "La hora de ingreso debe ser un número entre 0 y 23" },
      { field: "idMetododePago", condition: !formData.idMetododePago || formData.idMetododePago === 0, error: "Este campo es obligatorio", snackbar: "El método de pago es obligatorio" }
    ];

    for (const rule of rules) {
      if (rule.condition && !newErrors[rule.field]) {
        addError(rule.field, rule.error, rule.snackbar);
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useImperativeHandle(ref, () => ({
    validateForm,
    getFormData: () => formData,
  }));

  const fetchLatyLon = async () => {
    try {
      const id = clientInfo?.data?.id

      const response = await axios.get(APIURL.getCoordenadasId(id, 2))
      setLatitud(response.data[0].latitud)
      setLongitud(response.data[0].longitud)
      setShowMapModal(true)
    } catch (error) {
      console.error("Error al obtener coordenadas", error);
      enqueueSnackbar("Error al obtener coordenadas", { variant: "error" });
    }
  }

  return (
    <div className="p-6">
      {/* Rejilla adaptable para responsive */}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {/* Primera fila: Nombre, Tiempo, Metros, Ingresos y Gastos */}
        <div className="flex flex-col">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaStoreAlt className="mr-2 text-primaryBlue" />
            Nombre de Negocio
          </label>
          <input
            type="text"
            className="solcitudgrande-style"
            value={formData.nombreNegocio}
            name="nombreNegocio"
            onChange={handleFormChange}
          />
          {errors.nombreNegocio && (
            <span className="text-red-500 text-xs">{errors.nombreNegocio}</span>
          )}
        </div>
        <div className="col-span-1">
          <SelectField
            label="Tiempo del Negocio"
            icon={<FaClock />}
            value={formData.tiempoNegocio}
            onChange={handleFormChange}
            options={tiempoNegocio}
            name="tiempoNegocio"
            error={errors.tiempoNegocio}
          />
        </div>

        <div className="flex flex-col">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaRulerCombined className="mr-2 text-primaryBlue" />
            Metros
          </label>
          <input
            type="number"
            required
            className="solcitudgrande-style"
            value={formData.metros}
            onChange={handleFormChange}
            name={"metros"}
          />
          {errors.metros && (
            <span className="text-red-500 text-xs">{errors.metros}</span>
          )}
        </div>

        <div className="col-span-1">
          <label className={`text-xs font-medium mb-1 flex items-center text-gray-500`}>
            <FaCity className="mr-2 text-primaryBlue" />
            Jefe Inmediato
          </label>
          <input
            type="text"
            name="jefeInmediato"
            autoComplete="off"
            value={formData.jefeInmediato}
            onChange={(e) => {
              const onlyLetters = e.target.value.replace(/[^A-Za-z\s]/g, '').toUpperCase();
              setFormData(prev => ({
                ...prev,
                jefeInmediato: onlyLetters
              }));
            }}
            className="block w-full solcitudgrande-style"
          />
          {errors.jefeInmediato && (
            <span className="text-red-500 text-xs">{errors.jefeInmediato}</span>
          )}
        </div>
        <div className="col-span-1">
          <label className={`text-xs font-medium mb-1 flex items-center text-gray-500`}>
            <FaMobileAlt className="mr-2 text-primaryBlue" />
            Número Jefe
          </label>
          <input
            type="text"
            name="numeroJefe"
            value={formData.numeroJefe}
            onChange={handleFormChange}
            //onBlur={handleBlur}
            className="block w-full solcitudgrande-style"
            onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ""); }}
            maxLength={10}
            readOnly={clientInfo?.data?.idEstadoVerificacionSolicitud === 12}
          />
          {errors.numeroJefe && (
            <span className="text-red-500 text-xs">{errors.numeroJefe}</span>
          )}
        </div>

        <div className="flex flex-col">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaMoneyBillWave className="mr-2 text-primaryBlue" />
            Ingresos
          </label>
          <input
            type="number"
            required
            className="solcitudgrande-style"
            value={formData.ingresos}
            onChange={handleFormChange}
            name={"ingresos"}
          />
          {errors.metros && (
            <span className="text-red-500 text-xs">{errors.metros}</span>
          )}
        </div>
        <div className="flex flex-col">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaMoneyCheckAlt className="mr-2 text-primaryBlue" />
            Gastos
          </label>
          <input
            type="number"
            className="solcitudgrande-style"
            value={formData.gastos}
            onChange={handleFormChange}
            name={"gastos"}
          />
          {errors.gastos && (
            <span className="text-red-500 text-xs">{errors.gastos}</span>
          )}
        </div>

        {/* Segunda fila: Provincia, Cantón, Parroquia, Barrio */}
        <div className="flex flex-col">
          <SelectField
            label="Provincia"
            icon={<FaMapMarkerAlt />}
            value={formData.provincia}
            onChange={handleFormChange}
            options={provincia}
            name="provincia"
            error={errors.provincia}
          />
        </div>

        <div className="col-span-1">
          <SelectField
            label="Canton"
            icon={<FaStore />}
            value={formData.canton}
            onChange={handleFormChange}
            options={canton}
            name="canton"
            error={errors.canton}
          />
        </div>
        <div className="col-span-1">
          <SelectField
            label="Parroquia"
            icon={<FaStore />}
            value={formData.parroquia}
            onChange={handleFormChange}
            options={parroquia}
            name="parroquia"
            error={errors.parroquia}
          />
        </div>
        <div className="col-span-1">
          <SelectField
            label="Barrio"
            icon={<FaStore />}
            value={formData.barrio}
            onChange={handleFormChange}
            options={barrio}
            name="barrio"
            error={errors.barrio}
          />
        </div>

        <div className="lg:col-span-1">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaPhoneAlt className="mr-2 text-primaryBlue" />
            Teléfono
          </label>
          <input
            type="text"
            name="telefono"
            value={formData.telefono}
            onChange={handleFormChange}
            className="solcitudgrande-style"
            onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ""); }}
            maxLength={9}
            readOnly={clientInfo?.data?.idEstadoVerificacionSolicitud === 12}
          />
          {errors.telefono && (
            <span className="text-red-500 text-xs">{errors.telefono}</span>
          )}
        </div>

        <div className="lg:col-span-1">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaMobileAlt className="mr-2 text-primaryBlue" />
            Celular
          </label>
          <input
            type="text"
            name="celular"
            value={formData.celular}
            onChange={handleFormChange}
            className="solcitudgrande-style"
            onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ""); }}
            maxLength={10}
            readOnly={clientInfo?.data?.idEstadoVerificacionSolicitud === 12}
          />
          {errors.celular && (
            <span className="text-red-500 text-xs">{errors.celular}</span>
          )}
        </div>

        {/* Tercera fila: Calle Principal, Número Casa, Calle Secundaria, Referencia Ubicación */}
        <div className="flex flex-col">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaRoad className="mr-2 text-primaryBlue" />
            Calle Principal
          </label>
          <input
            type="text"
            required
            className="solcitudgrande-style"
            value={formData.callePrincipal}
            onChange={handleFormChange}
            name="callePrincipal"
          />
          {errors.callePrincipal && (
            <span className="text-red-500 text-xs">
              {errors.callePrincipal}
            </span>
          )}
        </div>

        {(clientInfo?.data?.idEstadoVerificacionSolicitud == 1 || clientInfo?.data?.idEstadoVerificacionSolicitud == 11) && (
          <div className="col-span-1">
            <label className="text-xs font-medium mb-1 flex items-center">
              <FaMapMarkerAlt className="mr-2 text-primaryBlue" />
              Ubicacion Trabajo
            </label>
            <button
              type="button"
              className="rounded-full hover:shadow-md transition duration-300 ease-in-out group bg-primaryBlue text-white border border-white hover:bg-white hover:text-primaryBlue hover:border-primaryBlue text-xs px-6 py-2.5 mb-4"
              name="verubicacionDomicilio"
              onClick={() => handleOpenModal("ubicacionDomicilio")}
            >
              Ubicacion Trabajo
            </button>
            {ubicacionError && (
              <p className="mt-1 text-sm text-red-500 border-red-500">
                No se han registrado coordenadas para este domicilio.
              </p>
            )}
          </div>)}

        {(clientInfo?.data.idEstadoVerificacionSolicitud == 12 || clientInfo?.data.idEstadoVerificacionSolicitud == 10 || clientInfo?.data?.idEstadoVerificacionSolicitud == 13) && (
          <div className="col-span-1">
            <label className="text-xs font-medium mb-1 flex items-center">
              <FaMapMarkerAlt className="mr-2 text-primaryBlue" />
              Ver Ubicacion Trabajo
            </label>
            <button
              type="button"
              className="rounded-full hover:shadow-md transition duration-300 ease-in-out group bg-primaryBlue text-white border border-white hover:bg-white hover:text-primaryBlue hover:border-primaryBlue text-xs px-6 py-2.5 mb-4"
              name="ubicacionDomicilio"
              onClick={fetchLatyLon}
            >
              Ver Ubicacion Trabajo
            </button>
            {ubicacionError && (
              <p className="mt-1 text-sm text-red-500 border-red-500">
                No se han registrado coordenadas para este domicilio.
              </p>
            )}
          </div>)}

        <div className="flex flex-col">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaHouseUser className="mr-2 text-primaryBlue" />
            Número Casa
          </label>
          <input
            type="text"
            required
            className="solcitudgrande-style"
            value={formData.numeroCasa}
            onChange={handleFormChange}
            name="numeroCasa"
          />
          {errors.numeroCasa && (
            <span className="text-red-500 text-xs">{errors.numeroCasa}</span>
          )}
        </div>

        <div className="flex flex-col">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaRoad className="mr-2 text-primaryBlue" />
            Calle Secundaria
          </label>
          <input
            type="text"
            required
            className="solcitudgrande-style"
            value={formData.calleSecundaria}
            onChange={handleFormChange}
            name="calleSecundaria"
          />
          {errors.numeroCasa && (
            <span className="text-red-500 text-xs">{errors.numeroCasa}</span>
          )}
        </div>

        <div className="flex flex-col lg:col-span-2">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaMapPin className="mr-2 text-primaryBlue" />
            Referencia Ubicación
          </label>
          <textarea
            className="solcitudgrande-style h-20"
            value={formData.referenciaUbicacion}
            onChange={handleFormChange}
            name="referenciaUbicacion"
            required
          />
          {errors.referenciaUbicacion && (
            <span className="text-red-500 text-xs">
              {errors.referenciaUbicacion}
            </span>
          )}
        </div>

        {/* Cuarta fila: Actividad del Negocio y Opciones */}
        <div className="flex flex-col lg:col-span-2">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaIndustry className="mr-2 text-primaryBlue" />
            Actividad del Negocio
          </label>
          <textarea
            className="solcitudgrande-style h-20"
            value={formData.actividadNegocio}
            onChange={handleFormChange}
            name="actividadNegocio"
            required
          />
          {errors.actividadNegocio && (
            <span className="text-red-500 text-xs">
              {errors.actividadNegocio}
            </span>
          )}
        </div>

        {/* Nuevos campos de Negocio */}
        <div className="col-span-1">
          <SelectField
            label="Tipo Ingreso"
            icon={<FaStore />}
            value={formData.idTipoIngreso}
            onChange={handleFormChange}
            options={tipoIngresoList}
            name="idTipoIngreso"
            error={errors.idTipoIngreso}
          />
        </div>
        <div className="col-span-1">
          <SelectField
            label="Día Ingreso"
            icon={<FaClock />}
            value={formData.idDiaIngreso}
            onChange={handleFormChange}
            options={diaIngresoList}
            name="idDiaIngreso"
            error={errors.idDiaIngreso}
          />
        </div>
        <div className="flex flex-col">
          <label className="text-xs font-medium mb-1 flex items-center">
            <FaClock className="mr-2 text-primaryBlue" />
            Hora Ingreso
          </label>
          <input
            type="number"
            min="0"
            max="23"
            required
            className="solcitudgrande-style"
            value={formData.iHora}
            onChange={handleFormChange}
            name="iHora"
          />
          {errors.iHora && (
            <span className="text-red-500 text-xs">{errors.iHora}</span>
          )}
        </div>
        <div className="col-span-1 lg:col-span-2">
          <SelectField
            label="Método de Pago (formas en la que va cancelar las cuotas)"
            icon={<FaMoneyCheckAlt />}
            value={formData.idMetododePago}
            onChange={handleFormChange}
            options={metodoPagoList}
            name="idMetododePago"
            error={errors.idMetododePago}
          />
        </div>

        {/* Opciones Adicionales */}
        <div className="col-span-1 lg:col-span-2 flex flex-col sm:flex-row gap-4">
          <label className="flex items-center p-3 border border-gray-200 rounded-xl hover:bg-blue-50 hover:border-blue-300 transition-all cursor-pointer w-full shadow-sm bg-white group">
            <input 
              type="checkbox" 
              className="w-5 h-5 text-primaryBlue rounded border-gray-300 focus:ring-primaryBlue cursor-pointer"
              checked={formData.AfiliadoTributario}
              onChange={(e) => setFormData({...formData, AfiliadoTributario: e.target.checked})}
            />
            <span className="ml-3 text-sm font-semibold text-gray-700 group-hover:text-primaryBlue transition-colors">Afiliado Tributario</span>
          </label>
          <label className="flex items-center p-3 border border-gray-200 rounded-xl hover:bg-blue-50 hover:border-blue-300 transition-all cursor-pointer w-full shadow-sm bg-white group">
            <input 
              type="checkbox" 
              className="w-5 h-5 text-primaryBlue rounded border-gray-300 focus:ring-primaryBlue cursor-pointer"
              checked={formData.ObligadoContabilidad}
              onChange={(e) => setFormData({...formData, ObligadoContabilidad: e.target.checked})}
            />
            <span className="ml-3 text-sm font-semibold text-gray-700 group-hover:text-primaryBlue transition-colors">Obligado a Llevar Contabilidad</span>
          </label>
        </div>
      </div>
      <LocationModal
        isOpen={() => handleOpenModal()}
        openLocationModal={openLocationModal}
        locationType={null}
        locationData={null}
        onLocationChange={null}
        userSolicitudData={data}
        tipo={2}
        userData={userData}
      />
      {/* MAP MODAL */}
      {showMapModal && Latitud && Longitud && (
        <GoogleMapModal
          lat={Latitud}
          lng={Longitud}
          apiKey={GOOGLE_MAPS_API_KEY}
          onClose={() => setShowMapModal(false)}
        />
      )}
    </div>
  );
});

export default SeccionA;
